import { makeStyles } from '@material-ui/core'

export default makeStyles((t) => ({
  content: {
    maxWidth: '640px',
    padding: '24px',
  },
  modal: {
    padding: '24px',
    textAlign: 'center',
    '& button': {
      minWidth: '150px',
    },
  },
}))
